import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopupComponent } from '../popup/popup.component';

@Component({
  selector: 'app-invite-popup',
  standalone: true,
  imports: [PopupComponent],
  templateUrl: './invite-popup.component.html',
  styleUrl: './invite-popup.component.scss',
})
export class InvitePopupComponent implements OnInit {
  @Input() show = false;
  @Output() closePopup = new EventEmitter<void>();

  linkCopied = false;
  registrationLink = '';

  ngOnInit(): void {
    // Set registration link with current hostname
    this.registrationLink = `${window.location.origin}/connection-self-signup`;
  }

  close(): void {
    this.linkCopied = false;
    this.closePopup.emit();
  }

  copyLink(link: string): void {
    navigator.clipboard.writeText(link).then(
      () => {
        this.linkCopied = true;
        // Reset the copied state after 3 seconds
        setTimeout(() => {
          this.linkCopied = false;
        }, 3000);
      },
      (err) => {
        console.error('Failed to copy link:', err);
      },
    );
  }
}
